module.exports = __webpack_public_path__ + "static/media/JU.350ff833.png";